import { Injectable } from '@angular/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
import { TranslateService } from '@ngx-translate/core';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShareService {

  constructor(private translate: TranslateService, private socialSharing: SocialSharing) { }


  async shareImage(fileName: string, path: string) {
    const savedFileMerge = await Filesystem.writeFile({
      path: fileName,
      data: path,
      directory: Directory.Documents
    }).then((writeFileResult) => {
      Filesystem.getUri({
        directory: Directory.Documents,
        path: fileName
      }).then((getUriResult) => {
        let shareRet = Share.share({
          title: 'Pesttrapp',
          url: getUriResult.uri,
          dialogTitle: this.translate.instant("general.share")
        });
      }, (error) => {
        console.log(error);
      });
    });
  }

  shareMultipleImage(list: Array<string>): Observable<boolean> {
    return new Observable(observer => {
      this.socialSharing.share("", "", list).then(e => {
          observer.next(true);
      });
    });
  }

  // socialSharing() {
  //   Filesystem.writeFile({
  //     data:
  //   })
  // }
}
